import { createSelector } from '@reduxjs/toolkit';
import { selectArticles } from './articlesSelectors';
import { selectCarType } from './vehicleDetailsSelectors';
import { getVatCalculationResult } from '@utils/sales/vat';

export const selectCartPrices = createSelector([selectArticles, selectCarType], (articles, carType) => {
  return getVatCalculationResult({
    articles,
    carType,
  });
});
